<div *ngIf="selecionado">
    <app-moeda-cadastro
      [model]="selecionado"
      (buscar)="buscar($event)"
      [state]="state">
    </app-moeda-cadastro>
  </div>
  <div *ngIf="!selecionado">
    <app-moeda-filtro [filtros]="filtros"></app-moeda-filtro>
    <app-moeda-lista
      [filtros]="filtros"
      (exibir)="selecionar($event)"
      (definirFiltro)="definirFiltro()">
    </app-moeda-lista>
  </div>